import * as React from "react";
import { Component, cloneElement } from "react";

import FieldError from "components/FormElements/FieldError";
import { FieldPropsType } from "components/FormElements/types";
import { getClasses } from "utils";

interface StateType {
  isDirty: boolean;
}

export default class Field extends Component<FieldPropsType, StateType> {
  static defaultProps = {
    onlyDirtyErrors: true,
  };

  state = {
    isDirty: false,
  };

  onChange = (event): void => {
    this.setState({ isDirty: true });
    this.props.onChange(event);
  };

  render(): JSX.Element {
    const {
      children,
      className,
      error,
      hidden,
      id,
      label,
      name,
      onlyDirtyErrors,
      toolTip,
    } = this.props;

    const isDirty = this.state.isDirty || !onlyDirtyErrors;

    const htmlFor = id || name;

    const Children = cloneElement(children, {
      id: htmlFor,
      name,
      onChange: this.onChange,
    });

    return (
      <div
        className={getClasses("form--field", {
          [className]: className,
          error: isDirty && error,
          [name]: name,
        })}
        {...{ hidden }}
      >
        <label className="form--field-label" {...{ htmlFor }}>
          <span>{label}</span>
          {toolTip}
        </label>

        {Children}
        <FieldError error={isDirty && error} />
      </div>
    );
  }
}
